// core
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';
import { RaptorFormService } from '@campfire-nx/raptor';

// services
import { RaptorManagerService } from '@open-portal-app/core/services/raptor-manager.service';

@Component({
  selector: 'quote-flow',
  templateUrl: './quote-flow.component.html',
  styleUrls: ['./quote-flow.component.scss']
})
export class QuoteFlowComponent implements OnInit, OnDestroy {
  data!: any;
  raptorStepSubscription!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private partnerBrandService: PartnerBrandService,
    private raptorFormService: RaptorFormService,
    private raptorManagerService: RaptorManagerService
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.data.step) {
      this.data = this.route.snapshot.data.step;
    }

    this.raptorStepSubscription = this.raptorFormService.step$
      .subscribe((data: any) => {
        this.partnerBrandService.setFlowBranding(data.formData);
        this.raptorManagerService.setStep(data);
      });
  }

  ngOnDestroy(): void {
    if (this.raptorStepSubscription) {
      this.raptorStepSubscription.unsubscribe();
    }
  }

}
